const REDIRECT_URL_FIELDS = [
  "3ds_url",
  "url3ds",
  "url",
  "returnWebUrl",
  "deepLinkUrl",
];

export const isKashierGateway = (gateway) =>
  gateway?.trim().toLowerCase() === "kashier";

export const shouldUseHostedRedirect = (response, gateway) =>
  Boolean(response?.redirect) || isKashierGateway(gateway);

export const getPaymentRedirectUrl = (response, gateway) => {
  const candidate = REDIRECT_URL_FIELDS.map((field) => response?.[field]).find(
    (value) => typeof value === "string" && value.trim()
  );

  if (!candidate) {
    return null;
  }

  const redirectUrl = candidate.trim();
  if (!isKashierGateway(gateway)) {
    return redirectUrl;
  }

  try {
    const url = new URL(redirectUrl);
    return url.protocol === "https:" && url.hostname === "payments.kashier.io"
      ? url.toString()
      : null;
  } catch (error) {
    return null;
  }
};
